import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/additionalChildcareLeaveAllowance/index'
import {Create} from 'pages/withAuth/adminPage/procedures/additionalChildcareLeaveAllowance/create'
import {AdditionalChildcareLeaveAllowanceFlow} from 'pages/withAuth/adminPage/procedures/additionalChildcareLeaveAllowance/flow'

export const AdditionalChildcareLeaveAllowanceRoutes: RouteParams[] = [
  {
    key: 'additional_childcare_leave_allowance',
    path: WITH_AUTH_ADMIN_PATHS.ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'additional_childcare_leave_allowance/create',
    path: WITH_AUTH_ADMIN_PATHS.ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE.CREATE,
    component: Create,
    exact: true,
  },
  {
    key: 'additional_childcare_leave_allowance/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE.FLOW,
    component: AdditionalChildcareLeaveAllowanceFlow,
    exact: true,
  },
]
